// Centralised base measurements and default styling tokens for the room preview.
export const WALL_DIMENSIONS_CM = {
  width: 200,
  height: 200,
};

export const WALL_HEIGHT_PX = 420;
export const FLOOR_HEIGHT_PX = 92;

export const DEFAULT_WALL_COLOR = '#f5f7fa';
export const DEFAULT_FLOOR_COLOR = '#cdb79f';
export const DEFAULT_MAT_WIDTH_CM = 4.5;

export const FRAME_STYLES = {
  black: {
    id: 'black',
    frameWidthCm: 2,
    matWidthCm: DEFAULT_MAT_WIDTH_CM,
    className: 'limited-edition-room-preview__frame--black',
  },
  white: {
    id: 'white',
    frameWidthCm: 2,
    matWidthCm: DEFAULT_MAT_WIDTH_CM,
    className: 'limited-edition-room-preview__frame--white',
  },
};
